import { Store, combineReducers, configureStore, Middleware } from '@reduxjs/toolkit';

import mw from './redux-mw';
import eraseableReducer from './reducer.helper';
import { loadStoreFromStorage, subscribe } from './persister';

// Note: thunk is already included by default in configureStore's getDefaultMiddleware
export const storeMiddlewares: Middleware[] = [mw];

const createStore = (initialState = {}, reducers: any, options = {}) => {
    const persistStore = { ...initialState, ...loadStoreFromStorage() };
    const rootReducer = eraseableReducer(combineReducers({ ...reducers }), options);

    const store: Store = configureStore({
        reducer: rootReducer,
        preloadedState: persistStore,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            thunk: true,
            immutableCheck: false,
            serializableCheck: false
        }).concat(storeMiddlewares)
    });

    return subscribe(store);
};

export default createStore;
